import UserActionPopupController from './user-action-popup.controller';
import { UserActionPopupProps } from './user-action-popup.model';

const UserActionPopup = (props: UserActionPopupProps) => {
  return <UserActionPopupController {...props} />;
};

export default UserActionPopup;
